<template>
    <div role="tabcard" class="tab-pane" id="archived-projects">

        <div v-if="loading" class="card card-default">
            <div class="card-header">
                <span class="loading-text">Loading...</span>
                <span class="loader float-right"></span>
            </div>
        </div>

        <div v-else-if="error" class="card card-default">
            <div class="card-header">
                <div class="">
                    <div><strong>Well, this is embarrassing.</strong> Something went wrong.</div>
                    <div>Please try refreshing the page, or otherwise <a href="mailto:support@sitecommandapp.com?subject=Help!">get in touch</a> and we'll be happy to help!
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div v-if="!loading && projects.length == 0">
                Nothing to see here.
            </div>
            <div v-else>
                <div class="mb-2 projects-header">
                    <div class="float-left">
                        <span>
                            <i class="fas fa-lock mr-1 text-muted"></i> {{ numberArchived }} {{ pluralProjects }} archived
                        </span>
                    </div>
                    <div class="float-right">
                         <span :class="expand ? 'link' : 'text-muted'" @click="clickedCompact">Compact view</span> | <span :class="!expand ? 'link' : 'text-muted'" @click="clickedExpand">Expanded view</span>
                    </div>
                </div>
                
                <project v-for="project in projects" :role="role" :project="project" :key="project.id" :expand="expand"></project>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user'],

        created: function() {
            this.registerEvents();
            this.getProjects();
        },

        mounted: function() {

        },

        data: function() {
            return {
                projects: [],
                loading: true,
                error: false,
                expand: false,
                numberArchived: 0,
            };
        },

        computed: {
            pluralProjects: function() {
                return this.numberArchived == 1 ? 'project' : 'projects';
            }
        },

        methods: {
            clickedCompact: function() {
                this.expand = false;
            },

            clickedExpand: function() {
                this.expand = true;
            },

            registerEvents: function() {
                var vm = this;
                Bus.$on('project-deleted', function (response) {
                    vm.projectDeleted(response);
                    return true;
                });
                Bus.$on('project-created', function (response) {
                    vm.projectCreated(response);
                    return true;
                });
            },

            projectDeleted: function() {
                this.refresh();
            },

            projectCreated: function() {
                this.refresh();
            },

            /**
             * Get the available member roles.
             */
            getProjects: function() {
                this.projects = [];
                axios.get(`/api/projects/archived`)
                    .then(response => {
                        this.loading = false;
                        this.error = false;
                        this.projects = response.data;
                        this.numberArchived = this.projects.length;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                        this.numberArchived = this.projects.length;
                    });
            },

            refresh: function() {
                this.loading = true;
                this.getProjects();
            },
        }
    }
</script>
